import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-ana-biz-statement-of-charges-select-sub-header',
  templateUrl: './ana-biz-statement-of-charges-select-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnaBizStatementOfChargesSelectSubHeaderComponent extends SupportComponent {
  backUrl = SERVICING_ROUTES.myBooking; // 予約詳細画面(S01-P030)
  constructor(commonService: CommonLibService) {
    super(commonService);
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
